<template>
    <div id="page-list">
        <loader :loading="true" v-if="loading" :fixed="true"></loader>
        <div>
            <div class="row actions" v-if="!noForecasts">
                <div class="col-12"><RequiredActionsWidget v-if="showRequiredActions" :show-spinner="false" /></div>
            </div>
            <div class="header-forecasts-list">
                <div class="row">
                    <div class="col-12 d-flex justify-content-end" v-if="isForecastManager || isZonesSupervisor">
                        <DefaultButton v-if="isForecastManager" :size="'l'" @click="$router.push(`${ROUTES.BASE}/create`)">
                            Create New Forecast
                        </DefaultButton>
                    </div>
                </div>
                <div class="row actions-header">
                    <div class="col-12 col-xl-9">
                        <template v-if="isForecastManager || isZonesSupervisor || isForecastZoneLevel">
                            <ForecastFilters :filter="isShowActiveOnly ? [FORECAST_STATUS.ACTIVE] : filter" @click="makeFilter"></ForecastFilters>
                        </template>
                    </div>
                    <div class="col-12 col-xl-3">
                        <template v-if="(isForecastManager || isZonesSupervisor) && forecastSelected.length > 1">
                            <ForecastMultiSelected :forecasts="forecastSelected" @updateLoading="updateLoading"></ForecastMultiSelected>
                        </template>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <table class="liste-forecasts" :class="isForecastZoneLevel ? 'isForecastZoneLevel' : ''">
                    <thead>
                        <tr>
                            <th v-if="isForecastManager || isZonesSupervisor" style="width: 50px;"></th>
                            <th class="id" style="width: 50px; max-width: 10%"></th>
                            <th class="ref" style="width: 130px">ref.</th>
                            <th class="name" style="width: 20%; min-width: 200px">name</th>
                            <th class="calendar" style="width: 20%; min-width: 200px"><CalendarIcon :color="'#5f5f60'" /></th>
                            <th class="markets" v-if="isForecastManager || isZonesSupervisor" style="min-width: 100px; width: 10%">
                                <WorldIcon :color="'#5f5f60'" />
                            </th>
                            <th class="items" style="min-width: 100px; width: 10%">items</th>
                            <th class="approved" style="min-width: 100px; width: 10%">approved</th>
                            <th class="xls" v-if="isForecastManager || isZonesSupervisor || isZoneReader" style="min-width: 100px; width: 10%">
                                xls
                            </th>
                            <th style="min-width: 70px; width: 8%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="forecast in filteredForecasts" v-if="isForecastManager || isZonesSupervisor">
                            <ForecastDetailBanner
                                :forecast="forecast"
                                :forecastSelected="forecastSelected"
                                v-bind:key="forecast.id"
                                @check="checkForecast"
                                @updateLoading="updateLoading"
                            />
                        </template>
                        <template v-for="window in filteredForecastWindows" v-if="isForecastZoneLevel">
                            <ForecastDetailBanner
                                :forecast="window.forecast"
                                :forecastSelected="forecastSelected"
                                :window="window"
                                :display-xls-export="isZoneReader"
                                v-bind:key="window.id"
                                @updateLoading="updateLoading"
                            />
                        </template>
                        <template v-for="window in filteredForecastWindows" v-else>
                            <ForecastDetailBanner
                                :forecast="window.forecast"
                                :forecastSelected="forecastSelected"
                                v-bind:key="window.id"
                                @updateLoading="updateLoading"
                            />
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="noForecasts" class="no-forecast-message row"><div class="title">No forecasts available</div></div>
    </div>
</template>
<style scoped lang="scss">
//@import "../../../assets/css/themes";
.header-forecasts-list {
    padding: 0 0 30px 0;
}
#page-list {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    background-color: #ffffff;
    padding: 20px;
}

.actions {
    margin-bottom: 50px;
}
.actions-header {
    margin: 15px auto;
}
.clickable {
    cursor: pointer;
}
.no-forecast-message {
    div {
        margin-left: auto;
        margin-right: auto;
    }
}

table.liste-forecasts {
    border-spacing: 0;
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    thead {
        th {
            font-weight: 400;
            font-family: Oswald, Sans-Serif;
            font-size: 17px;
            &.calendar,
            &.markets,
            &.items,
            &.xls,
            &.approved {
                text-align: center;
            }
            color: black;
        }
    }

    &.isForecastZoneLevel {
        border-collapse: collapse;
        table-layout: auto !important;
        width: 100%;
        overflow-x: scroll;
        thead {
            th {
                &.id {
                    width: 30px !important;
                }
                &.ref {
                    width: 100px !important;
                    min-width: 100px !important;
                }
                &.name {
                    width: 100px !important;
                }
            }
        }
    }
}
</style>
<script>
import ForecastCreate from "@/components/forecasts/pages/ForecastCreate";
import { ROUTES } from "@/components/forecasts/router";
import { FUNCTIONALITY } from "@/components/forecasts/constants";
import ClientColorButton from "@/components/ui/ClientColorButton";
import { mapActions, mapGetters } from "vuex";
import ForecastDetailBanner from "@/components/forecasts/elements/ForecastDetailBanner";
import TryLoad from "@/mixins/TryLoadMixin";
import loader from "@/components/loader/loader";
import forecastsService from "@/components/forecasts/forecastsService";
import { FORECAST_STATUS } from "@/components/forecasts/constants";
import ForecastStatus from "@/components/forecasts/elements/ForecastStatus";
import ForecastFilters from "@/components/forecasts/elements/ForecastFilters";
import cache from "@/services/cache";
import { PROFILES } from "@/plugins/AccessUserPlugin";
import RequiredActionsWidget from "@/components/forecasts/elements/widgets/RequiredActionsWidget";
import DefaultButton from "@/components/forecasts/elements/form/DefaultButton";
import { convertForecastInForecastWindow } from "@/components/forecasts/model/forecastWindow";
import CalendarIcon from "@/components/forecasts/elements/icons/CalendarIcon";
import WorldIcon from "@/components/forecasts/elements/icons/WorldIcon";
import Template from "@/plano/template";
import ForecastMultiSelected from "@/components/forecasts/elements/ForecastMultiSelected";

const MODES = {
    LIST: "LIST",
    CREATE: "CREATE"
};

export default {
    components: {
        ForecastMultiSelected,
        Template,
        DefaultButton,
        ForecastStatus,
        ForecastDetailBanner,
        ForecastCreate,
        ClientColorButton,
        loader,
        ForecastFilters,
        RequiredActionsWidget,
        CalendarIcon,
        WorldIcon
    },
    mixins: [TryLoad],
    data() {
        return {
            filter: [],
            forecastSelected: [],
            MODES,
            ROUTES,
            FUNCTIONALITY,
            userForecastWindows: [],
            FORECAST_STATUS,
            noForecasts: false,
            loading: true
        };
    },
    async created() {
        this.filter = cache.getFilterStatusForecast() ? cache.getFilterStatusForecast() : this.filter;
        this.filter = this.isShowActiveOnly ? [FORECAST_STATUS.ACTIVE] : this.filter;
        if (this.isForecastManager || this.isZonesSupervisor) {
            //TODO corriger localstorage droit
            // await this.tryLoad(() => this.populate());
            await this.populate();
            if (this.forecasts.length === 0) {
                this.noForecasts = true;
            }
        } else if (this.isForecastZoneLevel) {
            // let forecastWindows = await this.tryLoad(() => forecastsService.getForecastWindowsForByZones());
            let forecastWindows = await forecastsService.getForecastWindowsForByZones();
            forecastWindows = forecastWindows.map(fc => convertForecastInForecastWindow(fc));
            this.userForecastWindows = forecastWindows;
            if (this.userForecastWindows.length === 0) {
                this.noForecasts = true;
            }
        }
        this.loading = false;
    },
    computed: {
        ...mapGetters("forecast", { forecasts: "all" }),
        ...mapGetters("forecast", { forecastsActive: "active" }),
        ...mapGetters("forecast", { isShowActiveOnly: "isShowActiveOnly" }),
        myfilter() {
            return this.isShowActiveOnly ? [FORECAST_STATUS.ACTIVE] : this.filter;
        },
        isForecastManager() {
            return this.hasAccessByProfile(PROFILES.FORECAST_MANAGER);
        },
        isForecastZoneLevel() {
            return this.hasAccessByProfile(PROFILES.ZONE_FORECASTER) || this.hasAccessByProfile(PROFILES.ZONE_READER);
        },
        isZonesSupervisor() {
            return this.hasAccessByProfile(PROFILES.ZONES_SUPERVISOR);
        },
        isZoneReader() {
            return this.hasAccessByProfile(PROFILES.ZONE_READER);
        },
        filteredForecasts() {
            let filterBy = this.myfilter.length ? this.myfilter : [];

            // Tri de base des Forecasts par date de début décroissante (date la plus grande en 1er)
            const sortedForecasts = this.forecasts.sort((forecastA, forecastB) => {
                if (forecastA.startDate > forecastB.startDate) return -1;
                else if (forecastA.startDate < forecastB.startDate) return 1;
                else return 0;
            });

            // S'il un ou plusieurs filtres sont sélectionnés :
            if (filterBy.length) {
                // On applique ces tris
                const filteredForecasts = sortedForecasts.filter(forecast =>
                    filterBy.find(filter => (filter === forecast.status && !forecast.deleted) || (forecast.deleted && filter === "DELETE"))
                );

                return filteredForecasts;
            }
            return sortedForecasts;
        },
        filteredForecastWindows() {
            let filterBy = this.myfilter.length ? this.myfilter : [];

            let filteredWindows = [];

            if (filterBy.length) {
                filteredWindows = this.userForecastWindows.filter(window =>
                    filterBy.find(
                        filter => (filter === window.forecast.status && !window.forecast.deleted) || (window.forecast.deleted && filter === "DELETE")
                    )
                );
            } else {
                filteredWindows = this.userForecastWindows;
            }

            // Filtrer par ordre décroissant des dates de début de forecast
            return filteredWindows.sort((fWindowA, fWindowB) => {
                if (fWindowA.forecast.startDate > fWindowB.forecast.startDate) return -1;
                if (fWindowA.forecast.startDate < fWindowB.forecast.startDate) return 1;
                return 0;
            });
        },
        showRequiredActions() {
            return (
                this.hasAccessByProfile(PROFILES.ZONE_FORECASTER) ||
                this.hasAccessByProfile(PROFILES.ZONES_SUPERVISOR) ||
                this.hasAccessByProfile(PROFILES.FORECAST_MANAGER)
            );
        }
    },
    methods: {
        ...mapActions("forecast", { populate: "populate" }),
        ...mapActions("forecast", { setIsShowActiveOnly: "setIsShowActiveOnly" }),
        makeFilter(filter) {
            if (filter !== -1) {
                this.filter = this.myfilter;
                this.setIsShowActiveOnly(false);
                let isPresent = this.filter.find(f => f === filter);
                if (isPresent) {
                    const index = this.filter.indexOf(filter);
                    this.filter.splice(index, 1);
                } else {
                    this.filter.push(filter);
                }
                cache.setFilterStatusForecast(this.filter);
            } else {
                this.filter = [];
                this.setIsShowActiveOnly(false);
                cache.remove("filterStatusForecast");
            }
            this.forecastSelected = [];
        },
        checkForecast(forecastId) {
            const forecast = this.filteredForecasts.find(f => f.id === forecastId);
            const isPresent = this.forecastSelected.find(f => f === forecast);

            if (isPresent) {
                const index = this.forecastSelected.indexOf(forecast);
                this.forecastSelected.splice(index, 1);
            } else {
                this.forecastSelected.push(forecast);
            }
        },
        updateLoading(bool) {
            this.loading = bool;
        }
    }
};
</script>



// WEBPACK FOOTER //
// ForecastsList.vue?7a72b613